<template>
	<div class="popup" v-if="isVisible">
	  <div class="popup-overlay" @click="closePopup"></div>
	  <div class="popup-content" @click.stop>

		<div class="content-area" v-html="popupMessage"></div>
		<header>
			<button class="agreen_btn" @click="closePopup">同意</button>
		</header>
	  </div>
	</div>
  </template>
  
  <script>
  export default {
	props: ['isVisible', ''],
	methods: {
	  closePopup() {
		this.$emit('close');
	  }
	},
	data() {
		return {
			isPopupVisible: false,
			popupMessage: `
       <p>隐私政策</p>
<p>最近更新日期：2025年2月27日</p>
<p>引言&nbsp;</p>
<p>嘉康利（中国）日用品有限公司（以下简称&ldquo;嘉康利&rdquo;或&ldquo;我们&rdquo;）深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽全力保护您的个人信息安全可靠。鉴于此，我们制定本《隐私政策》（下称&ldquo;本政策&nbsp;/本隐私政策&rdquo;），并提醒您：</p>
<p>本政策适用于我们提供的所有产品和/或服务。当您访问我们的网站、微信公众号、小程序或其他应用（&ldquo;本网站及相关应用&rdquo;）；或当您申请成为我们的会员（包括但不限于直销员、嘉友、及其他会员）；或当您参与我们的市场推广/营销活动、培训、奖励计划；购买或使用我们的产品和/或接受各项服务时，我们可能会收集和使用您的相关信息。我们希望通过本隐私政策，向您说明我们如何收集、使用、保存、委托、共享、转让和公开这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</p>
<p>请务必仔细阅读并了解本隐私政策，在确认充分理解并同意后使用我们的产品与/或服务，并让您可以按照本隐私政策的指引做出您认为适当的选择。如对本政策内容有任何疑问、意见或建议，您可通过本隐私政策提供的联系方式与我们联系。</p>
<p><strong>如您登录我们的网站，希望您在使用我们的服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并按照本政策的指引做出您认为适当的选择。</strong></p>
<p><strong>如您登录其他相关应用，您勾选或点击同意后，即意味着您同意本政策的内容，并且同意我们按照本政策收集、使用、保存和共享您的相关信息。您只需一次勾选或点击同意，该选择在您之后的每次连续登录同一账号时均适用，除非本政策更新或您根据本政策的指引有效通知我们您不再同意本政策。</strong></p>
<p>本政策将帮助您了解以下内容：</p>
<p>1、我们如何收集和使用您的个人信息</p>
<p>2、我们如何使用&nbsp;Cookies技术</p>
<p>3、我们如何委托、共享、转让、公开披露您的个人信息</p>
<p>4、我们如何存储您的个人信息</p>
<p>5、我们如何保护您的个人信息</p>
<p>6、您如何管理您的个人信息</p>
<p>7、我们如何处理未成年人的信息</p>
<p>8、本政策如何更新</p>
<p>9、如何联系我们</p>
<p><strong>一、我们如何收集和使用您的个人信息&nbsp;</strong></p>
<p>个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息，不包括匿名化处理后的信息。</p>
<p>敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
<p><strong>（一）您须授权我们收集和使用您个人信息的情形</strong></p>
<p>不同情况下，我们将会收集您不同的个人信息。我们为本隐私政策中列明的目的而收集并使用这些信息。<strong>如具体应用的隐私保护政策中有另行说明，请以相关应用的隐私保护政策为准。</strong></p>
<p>1、帮助您完成注册和登录</p>
<p>当您注册会员和登录时，我们可能会收集您主动提供或分享的<strong>姓名、身份证件、手机号码、地址及银行账户、微信昵称、微信头像、</strong>微信转发分享的社交信息、您投资成立或担任重要职务的营利法人、非法人组织或个体工商户的营业执照、嘉康利会员编号等信息，以便您注册会员和登录。</p>
<p>2、为您提供商品或服务信息展示</p>
<p><strong>为了让您快速地找到您所需要的商品或服务，我们可能会收集您使用本网站及相关应用的设备信息（包括设备识别码、操作系统、应用程序版本、语言设置）来为您提供商品/服务信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</strong></p>
<p>您可以通过搜索来精准地找到您所需要的商品或服务。我们可能会收集您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品。</p>
<p><strong>请您注意，您的搜索关键词是无法识别特定自然人身份的信息。我们有权以任何的目的对其进行使用；只有当您的上述信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的上述信息作为您的个人信息，按照本隐私政策对其进行处理与保护。</strong></p>
<p>3、公开展示您的个人信息</p>
<p>如您使用<strong>我们为您提供的评论、问答、晒单分享、产品种草笔记发布、直播及其他信息发布功能公开发布信息，包括发布图文/视频/直播内容、发表评价等，您的微信昵称、微信头像、发布内容和店铺名会被收集并公开展示。请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至敏感个人信息（例如您在评价时选择上传包含个人头像信息的图片）。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及未成年人个人信息的，您需在发布前征得对应未成年人监护人的同意。</strong></p>
<p>4、为您提供购货服务</p>
<p>（1）完成下单及订单管理</p>
<p>当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,我们至少需要收集您提供的<strong>收货信息</strong>，包括<strong>收货人姓名、收货地址、收货人联系电话、支付信息如订单金额等</strong>用于完成您的订单。<strong>订单信息</strong>包括<strong>收货信息</strong>、订单编号、下单时间、支付方式、支付时间、<strong>支付金额</strong>、交易单号、配送方式、服务门店、订单渠道、确认收货时间，同时该订单中会载明<strong>您所购买的商品及/或服务信息</strong>，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。</p>
<p>为便于您了解查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。</p>
<p>（2）帮助您完成支付</p>
<p>为帮助您完成支付，<strong>支付功能由与我们合作的第三方支付机构向您提供服务，我们需要将收集到的您必要的订单支付相关信息（如订单金额）、订单安全相关必要设备信息及其他反洗钱法律要求的必要信息等与支付平台共享。</strong></p>
<p>（3）帮助向您完成交付</p>
<p>为保证您购买的商品、赠品、奖品及/或服务能够顺利、安全、准确送达，我们会向为嘉康利提供物流配送服务的第三方配送公司披露订单相关<strong>配送信息（包括购货人、收货人、联系电话、收货地址、购买商品名称、购买商品数量）</strong>。<strong>如上您提供的收货地址，可能为您的精确地理位置信息，属于您的敏感个人信息，拒绝向我们提供您将无法收到我们为您配送的商品（包括赠品、奖品）<em><em>。</em></em></strong>您知晓并同意相应物流配送主体不可避免地获知及使用您的<strong>配送信息</strong>，用于完成交付目的。如果您拒绝共享此类信息，我们将无法完成相关交付服务。</p>
<p>为使我们及时获悉并确认交付进度及状态，向您提供售后与争议解决服务，您同意我们可自物流相关服务主体处收集与交付进度相关信息。</p>
<p><strong>您购货过程中提供的支付信息、配送信息、订单信息属于您的敏感个人信息，收集此类信息是为了满足您购买嘉康利产品付款及我们为您寄送商品、赠品、奖品的需求。&nbsp;</strong></p>
<p>为确保相关商品购买行为为您本人真实意思表示的交易行为，我们会在收货人的收货单上展示您的嘉康利编号以及与之对应的您的姓名或昵称。若您向我们提交非您本人的收货信息，则视为您授权我们向您指定的收货人通过收货单展示购物明细信息、您的嘉康利编号以及与之对应的您的姓名或昵称。</p>
<p>5、支持您的委托购货需求</p>
<p>若您是我们的会员，当您不方便自行购货，需要授权其他会员为您购货时，为支持该需求，我们将收集由您指定的实际购货人主动提供的您的嘉康利编号、购买明细（购买商品名称、购买商品数量）、联系电话、收货人、收货地址，并在收货人的收货单上予以展示。</p>
<p><strong>其中您的购买明细、收货信息（包括精确地理位置信息），属于您的敏感个人信息，若您拒绝提供，我们将无法支持您的委托购货需求。</strong></p>
<p>6、客服及争议处理</p>
<p>当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的信息安全，我们可能需要您提供相关的个人信息（包括会员信息）、订单信息以核验您的身份。为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会收集您与我们沟通信息（包括<strong>账号信息</strong>、<strong>订单信息、身份证件信息、您为了证明相关事实提供的其他信息</strong>）、<strong>您的联系方式，</strong>如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的购货信息和订单信息。同时，我们可能会以电话、短信、App站内信及相关方式主动联系您，沟通您在使用我们产品及服务过程中产生的问题。</p>
<p><strong><u>为保证服务的体验、处理服务纠纷，您与客服间的通话信息可能会被录音。您与我们通话信息内容，以及您与客服联系时您提供的相关信息可能涉及敏感个人信息，若您拒绝提供，您可挂断电话或终止沟通，很遗憾我们也将无法为您提供客户服务。</u></strong></p>
<p>我们可能会根据法律法规规定或政府主管部门的强制性要求，向监管/执法机构共享您的相关个人信息。</p>
<p>若您需要反馈的是产品使用体验的相关问题，如不良反应情况，我们可能需要您提供您的年龄、<strong>身体健康状况、</strong>使用产品名称、用量、<strong>展现不良反应的相关图片</strong>等与产品使用体验相关的事实情况。</p>
<p>7、参与直播活动奖品的交付</p>
<p>为保证您参与嘉康利直播间活动所获奖品能够顺利、安全、准确送达，我们会向为嘉康利提供物流配送服务的第三方配送公司披露您提供的相关<strong>配送信息（包括收货人、联系电话、收货地址）。如上您提供的收货地址，可能为您的精确地理位置信息，属于您的敏感个人信息，拒绝向我们提供您将无法收到我们为您配送的奖品。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。如果您拒绝共享此类信息，我们将无法完成相关交付服务。</strong></p>
<p>为使我们及时获悉并确认交付进度及状态，向您提供查询与争议解决服务，您同意我们可自物流相关服务主体处收集与交付进度相关信息。</p>
<p><strong>您提供的配送信息属于您的敏感个人信息，收集此类信息是为了向您寄送奖品的需求。</strong></p>
<p>8、服务正常维护</p>
<p>为向您提供服务，维护我们服务的正常运行，优化服务体验以及保障您的网络系统安全，我们会收集您的设备信息及您使用本服务过程中的操作行为所产生的日志信息。</p>
<p>9、向您推送消息</p>
<p>为了使您接收到我们服务调整信息、商品咨讯或其他通知，我们会收集您的<strong>手机号码</strong>，进行加密后通过我们的第三方合作伙伴，向您推送相关信息。如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息等；但我们依法律规定约定发送消息的情形除外。</p>
<p>在您访问本网站及相关应用过程中，我们可能会通过PUSH消息、弹窗等方式向您发送一种或多种类型的消息通知，例如、身份验证、新消息提醒、系统服务通知等。</p>
<p>10、向您提供收藏、加购、关注与分享功能</p>
<p>我们会收集您的服务日志信息及其他实现上述目的所必需的信息。</p>
<p>11、为您提更好的服务及供业务支持</p>
<p>为了给您提供更好的服务及业务支持，我们可能会收集<strong>您的姓名、嘉康利编号、手机号码、购买情况、您可能感兴趣的商品/话术/文章、您领取、使用和分享优惠券的情况、您访问商品的情况、您参与市场活动的情况、您的微信头像、微信昵称和微信社交信息（如您将我们的商品/话术/文章/活动信息/优惠券/页面分享给某微信好友）、您的调查问卷回复、设备信息、服务日志信息、积分信息、积分使用</strong>情况等。</p>
<p>12、为您提供培训、奖励计划及其他活动安排</p>
<p>当您参与嘉康利组织的培训、奖励计划及其他活动（如调查问卷），我们可能会收集您的姓名、嘉康利编号、<strong>身份证、护照签证</strong>、<strong>年龄、性别、联系地址</strong>、<strong>手机号码、业绩达成情况、交通信息、组织活动和安排行程所必需的信息（如个人生活习惯及健康信息），以便提前准备上述培训、奖励计划和活动相关事宜。</strong></p>
<p><strong>其中您的身份证、护照签证、个人健康信息属于敏感个人信息，若您不提供这类该信息，您可能无法正常参与我们举办的活动，但不影响您正常使用我们的其他服务。</strong></p>
<p>为实现上述目的，我们可能会委托合作伙伴，向其提供上述全部或部分信息。</p>
<p>13、改进我们的服务及个性化</p>
<p>为维护、改进我们的产品或服务质量，向您提供个性化的服务或定制产品，我们可能会在符合法律规定并根据您具体授权的情况下收集并使用如下信息：</p>
<p>（i）我们可能会收集您的<strong>订单信息</strong>、<strong>浏览及搜索信息、微信转发分享的社交信息等，以及将您在本网站及相关应用上使用某项服务中提供的信息与来自其他服务中的信息结合起来，进行综合统计、分析以形成用户画像，用来向您推荐或展示您可能感兴趣的商品或服务，或者通过系统向您展示个性化的推广信息</strong>。包括在微信公众号、小程序页面向您推送消息通知，为您提供智能推荐，给您发送推广短信等。&nbsp;</p>
<p>（ii）<strong>您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。</strong></p>
<p>14、基于设备权限的扩展功能</p>
<p>本项中的扩展功能可能需要您在您的移动设备中向我们开启您的相机（摄像头）、相册（图片库）的访问权限，以实现本网站及相关应用的功能所涉及的信息的收集和使用。您可以通过访问【&ldquo;账户设置&mdash;通用&mdash;隐私设置&rdquo;】页面逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。<strong>请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</strong></p>
<p>（i）&nbsp;基于摄像头（相机）的扩展功能：<strong>您可以使用这项扩展功能完成视频拍摄、拍照、扫码的功能。</strong></p>
<p>（ii）基于图片上传的扩展功能：您可以在本网站及相关应用上传您的照片来实现晒单、评价及问答功能，<strong>我们可能使用包含您所上传图片或视频的晒单、评价及问答内容。</strong></p>
<p>15、其他</p>
<p>除上述目的外，<strong>为提高您使用本网站及相关应用的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规的情况，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账户及交易风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接(&ldquo;URL&rdquo;)。</strong></p>
<p><strong>嘉康利的总部位于美国，其所关联实体位于全世界的众多国家和地区。为了向您提供服务，包括个人信息在内的信息和数据可能会被转移至中国境外，并被位于中国境外的、我们所关联的实体所获取。当我们将您的个人信息转移至其他国家或地区时，我们将遵守所适用的中国法律法规。</strong></p>
<p><strong>若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及未成年人个人信息的，您需在提供前取得对应未成年人监护人的同意，前述情形下个监护人有权通过本政策所述途径联系我们，要求更正或删除涉及相关个人信息的内容。</strong></p>
<p><strong>若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意</strong>。</p>
<p><strong>若我们从第三方主动获取您的个人信息，我们会在收集前明确要求该第三方符合法律法规的所有规定，包括但不限于征得您的同意。</strong></p>
<p><strong>(二)&nbsp;第三方链接</strong></p>
<p><strong>为了方便您的使用，嘉康利线上平台可能会有选择地提供第三方网站的链接。我们无权管理和控制这些第三方网站，我们建议您在使用前仔细阅读其个人信息保护政策。</strong></p>
<p><strong>（三）征得授权同意的例外</strong></p>
<p>您充分理解并同意，根据中国相关法律法规，我们在以下情况下收集、使用您的个人信息无需您的授权同意：</p>
<p>（1）与我们履行法律法规规定的义务相关的</p>
<p>（2）与国家安全、国防安全有关的；</p>
<p>（3）与公共安全、公共卫生、重大公共利益有关的；</p>
<p>（4）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
<p>（5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
<p>（6）您自行向社会公众公开的；</p>
<p>（7）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
<p>（8）根据与您签订和履行相关协议或其他书面文件所必需的；</p>
<p>（9）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
<p>（10）为合法的新闻报道所必需的；</p>
<p>（11）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
<p>（12）法律法规规定的其他情形。</p>
<p><strong>（四）您个人信息使用的规则</strong></p>
<p>1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</p>
<p>2、<strong>在收集您的个人信息后，若我们通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong></p>
<p>3、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。当您符合约定的会员号注销条件并注销后，我们将不会再收集、对外提供与该会员号相关的个人信息，但您在使用嘉康利服务期间提供或产生的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询。</p>
<p>4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
<p>5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</p>
<p>6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。</p>
<p><strong>二、我们如何使用&nbsp;Cookies技术</strong></p>
<p>在您使用我们的产品或服务时，我们的平台会自动接收并记录您的浏览器和计算机上的信息，其中包括您的&nbsp;IP&nbsp;地址，软硬件特征信息、以及您需求的网页记录，Cookie&nbsp;中的信息等。为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。在您未拒绝接受Cookies的情况下，Cookies将被发送到您的浏览器，并储存在您的计算机硬盘。我们使用Cookies储存您访问我们网站的相关数据，在您访问或再次访问我们的网站时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。您有权选择接受或拒绝接受Cookies。您可以通过修改浏览器的设置以拒绝接受Cookies，但是我们需要提醒您，因为您拒绝接受Cookies，您可能无法使用依赖于Cookies的部分功能。</p>
<p><strong>三、我们如何委托、共享、转让、公开披露您的个人信息</strong></p>
<p><strong>（一） 委托</strong></p>
<p>我们可能会委托授权合作方处理您的个人信息，以便授权合作方代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要的目的委托其处理您的信息，授权合作方只能处理其履行职责所需信息，且我们会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作方将您的信息用于我们未委托的用途，其将单独向您告知并征得您的同意。</p>
<p><strong>（二）共享</strong></p>
<p><strong>1、我们不会与嘉康利以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</strong></p>
<p>（1）根据适用的法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
<p>（2）事先获得您明确的同意或授权（包括我们根据您对本政策的同意而获得授权）；</p>
<p>（3）在法律法规允许的范围内，为维护嘉康利、嘉康利的关联方或合作伙伴、您或其他嘉康利会员、客户或社会公众利益、财产或安全免遭损害而有必要提供；</p>
<p>（4） 只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；</p>
<p>（5）应您需求为您处理您与他人的纠纷或争议；</p>
<p>（6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
<p>（7）基于符合法律法规的社会公共利益而使用。</p>
<p>2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
<p>3、为了便于您更好的了解、使用嘉康利产品，更好地向您提供产品咨询、售后等相关服务，我们可能会以适当形式与推广服务人员共享您的相关个人信息。</p>
<p>4、<strong>我们的某些服务将由供应商提供。为实现本政策中声明的目的，我们可能会向供应商共享您的订单信息、账户信息、设备信息、配送信息、身份证号码、护照信息等，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的供应商无权将共享的个人信息用于任何其他用途。</strong></p>
<p>上述供应商可能包括：</p>
<ul>
<li>审核注册身份信息的信用信息服务供应商</li>
<li>提供配送服务的物流服务供应商</li>
<li>提供支付结算服务的结算服务供应商</li>
<li>提供交通、住宿、票务等服务的旅行代理服务供应商</li>
<li>社交平台运营商以及通讯服务供应商，例如邮件送达供应商</li>
<li>提供市场调研服务的供应商</li>
<li>提供培训、推广活动等服务的供应商</li>
</ul>
<p>根据合同约定，<strong>该等供应商仅可在其履行合同义务所必需的范围内，使用我们提供的个人信息，例如您的姓名、身份证号码、电话号码、地址、银行账户、个人健康信息、浏览记录、订单信息、配送信息、支付信息，并且无权为其他目的使用我们所提供的个人信息</strong>。我们会要求供应商按照我们的说明、本政策以及其他任何相关的保密及安全措施的要求来使用您的个人信息。</p>
<p><strong>5、授权合作伙伴的SDK</strong></p>
<p>为了使您能够更好地使用我们的服务及功能，本网站及相关应用中可能会嵌入授权合作伙伴的SDK，SDK提供方会基于向您提供功能或服务之必须获取相应信息。请您详细阅读我们下述列表，了解SDK相关信息。如您同意本政策，视为您授权并同意SDK提供方按照以下内容获取并处理您的信息。具体如下：</p>
<p><strong>（1）订单支付（微信SDK）</strong></p>
<p>场景描述：当用户在微信内付款时</p>
<p>使用目的：实现付款</p>
<p>收集的个人信息：unionid、openid、订单号、订单金额</p>
<p>获取的系统权限：无</p>
<p>适用的系统：H5、小程序</p>
<p>收集方式：SDK本机收集</p>
<p>SDK提供方：深圳市腾讯计算机系统有限公司</p>
<p>隐私政策链接：https://www.qq.com/yszc.htm</p>
<p><strong>（2）电子合同签署（e签宝SDK）</strong></p>
<p>场景描述：用户注册时；转经销商时</p>
<p>使用目的：个人信息三要素真实性认证；企业信息真实性认证</p>
<p>收集的个人信息：姓名，身份证号，手机号，营业执照统一信用社代码，执照名称，法人姓名，法人银行卡</p>
<p>获取的系统权限：无</p>
<p>适用的系统：H5、小程序</p>
<p>收集方式：SDK本机收集</p>
<p>SDK提供方：杭州天谷信息科技有限公司</p>
<p>隐私政策链接：https://www.esign.cn/c/2024-01-04/498143.shtml</p>
<p><strong>（3）短信推送（阿里大鱼SDK）</strong></p>
<p>场景描述：用户登录注册时</p>
<p>使用目的：手机验证码短信推送</p>
<p>收集的个人信息：手机号码</p>
<p>获取的系统权限：无</p>
<p>适用的系统：H5、小程序</p>
<p>收集方式：SDK本机收集</p>
<p>SDK提供方：阿里巴巴集团控股有限公司</p>
<p>隐私政策链接：<a href="https://ali-home.alibaba.com/privacy-policy">https://ali-home.alibaba.com/privacy-policy</a></p>
<p><strong>（三）转让</strong></p>
<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
<p>1、获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
<p>2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</p>
<p>3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
<p>4、<strong>在涉及合并、收购、破产清算及其他类似交易时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</strong></p>
<p><strong>（四）公开披露</strong></p>
<p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，公开披露您的个人信息：</p>
<p>1、根据您的需求，在您明确同意或主动选择的方式下披露您所指定的个人信息；</p>
<p>2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</p>
<p><strong>&nbsp;四、我们如何存储您的个人信息</strong></p>
<p>(一)我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如为本政策所陈述之目的，我们需要向境外机构传输境内收集的相关个人信息或将境内收集的相关个人信息存储在境外的，我们会按照法律法规和相关监管部门的规定执行。</p>
<p>（二）我们仅在本政策所属目的所必须期间和法律法规要求的时限内存储您的个人信息。</p>
<p>（三）但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
<p>1、为遵守适用的法律法规等有关规定；</p>
<p>2、为遵守法院判决、裁定或其他法律程序的规定；</p>
<p>3、为遵守相关政府机关或法定授权组织的要求；</p>
<p>4、我们有理由确信需要遵守法律法规等有关规定；</p>
<p>5、为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他消费者或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
<p><strong>五、我们如何保护您的个人信息</strong></p>
<p>（一）我们会采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如：通过网络安全层软件（SSL）进行加密传输、信息加密存储、严格限制数据中心的访问、使用专用网络通道及网络代理。同时我们设立了数据安全职能，建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。另外，我们还会在必要时聘请外部独立第三方对我们的信息安全管理体系进行评估，委托可信赖的合作伙伴协助我们不断完善及提升数据安全水平。</p>
<p>（二）我们通过向其它服务器备份数据和对用户密码加密等安全措施，来确保您的信息不丢失，不被滥用和变造。</p>
<p>（三）我们会采取一切合理可行的措施，尽量避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。而我们判断前述期限的标准包括：</p>
<p>1、完成与您相关的交易、合作目的、维护相应交易及业务记录、应对您可能的查询、投诉及售后服务；</p>
<p>2、保证我们为您提供商品和/或服务的安全和质量；</p>
<p>3、您是否对保留期限作出特别授权；</p>
<p>4、需要满足财务、审计、争议处理等目的；</p>
<p>5、是否存在保留期限的其他特别约定。</p>
<p>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
<p>（四）我们会依法处理个人信息安全事件，并组织相关工作人员培训，使其掌握岗位职责和应急处置策略和规程。在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
<p>（五）请您务必妥善保管好您的会员号信息及其他身份要素。您在使用嘉康利的产品或服务时，我们会通过您的会员号信息及其他身份要素来识别您的身份。<strong>一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果，对此将由您自行承担相应后果</strong>。如您发现会员号信息及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
<p>（六）如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>
<p>（七）当您成功申请注销嘉康利会员后，我们将在您提出申请后完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。</p>
<p><strong>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入嘉康利服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</strong></p>
<p><strong>六、您如何管理您的个人信息</strong></p>
<p>嘉康利非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、补充、删除、撤回同意以及注销的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
<p><strong>（一）访问、更正和补充您的信息</strong></p>
<p>您有权随时访问、更正和补充您的个人信息。您可以通过以下方式自行进：</p>
<p>1、您可以在我们的微信平台为您提供的相应的界面中进行操作。</p>
<p>2、请与我们的客服联系，协助您查询、更正或补充您的信息。我们的联系方式请见下文。</p>
<p><strong>（二）删除您的个人信息</strong></p>
<p>1、您可以与我们的客服联系，协助您删除您的个人信息。</p>
<p>2、以下情况发生时，您有权要求我们删除您的个人信息：</p>
<p>（1）我们没有征求您的明确同意，收集了您的个人信息。</p>
<p>（2）我们处理您的个人信息违反了法律法规要求。</p>
<p>（3）我们违反了与您的约定来使用和处理您的个人信息。</p>
<p>当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其进一步处理隔离，直到备份可以清除或实现匿名。</p>
<p><strong>（三）改变您授权同意的范围或撤回您的授</strong>权</p>
<p>您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。</p>
<p><strong>每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再继续收集或处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong></p>
<p><strong>（四）注销您的会员号</strong></p>
<p>您可以在任何时候要求注销您的注册会员号。您可以通过以下方式进行：</p>
<p>请与我们的客服联系，协助您注销您的账户。我们的联系方式请见下文。</p>
<p>在会员号注销后，除非法律或法规有其他规定，我们将停止向您提供任何服务。</p>
<p><strong>（五）响应您的请求和投诉</strong></p>
<p>嘉康利非常重视隐私权问题。若您对本隐私权政策或相应的个人信息保护权利有疑问，您可以通过本政策公布的方式与我们联系。<strong>为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。一般情况下，我们将在三十天内响应。对于您合理的请求</strong>。对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</p>
<p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
<p>1、与我们履行法律法规规定的义务相关的；</p>
<p>2、与国家安全、国防安全有关的；</p>
<p>3、与公共安全、公共卫生、重大公共利益有关的；</p>
<p>4、与犯罪侦查、起诉、审判和执行判决等有关的；</p>
<p>5、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
<p>6、出于维护我们或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
<p>7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
<p>8、涉及商业秘密的。</p>
<p><strong>七、我们如何处理未成年人的信息</strong></p>
<p><strong>1、我们通过嘉康利线上平台等渠道提供的服务以及业务活动主要面向成年人。如果没有父母或监护人的同意，未成年人不得创建自己的会员号。</strong></p>
<p><strong>2、嘉康利非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。嘉康利根据国家相关法律法规的规定保护未成年人的个人信息。</strong></p>
<p><strong>3、对于经父母或监护人同意而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、或披露此信息。</strong></p>
<p><strong>4、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</strong></p>
<p><strong>若您是未成年人的父母或其他监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用我们的产品及/或服务。如您对您所监护的未成年人的个人信息有疑问，请通过本政策中第九条的的联系方式与我们联系。</strong></p>
<p><strong>八、本政策如何更新</strong></p>
<p>我们的隐私政策可能变更。</p>
<p>未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在相应的渠道发布对本政策所做的任何变更。</p>
<p>对于重大变更，我们还会提供更为显著的通知（包括我们会通过邮件、短信或网站公告等方式发送通知，说明隐私政策的具体变更内容）。</p>
<p>本政策所指的重大变更包括但不限于：</p>
<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
<p>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
<p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
<p>6、个人信息安全影响评估报告表明存在高风险时。</p>
<p><strong>九、如何联系我们&nbsp;</strong></p>
<p>如果您对我们的隐私政策及对您个人信息的处理有任何疑问、意见、建议或投诉，可通过客服电话400-6280-110&nbsp;来反馈，我们会尽快回复。</p>
<p>一般情况下，我们将在三十天内响应。</p> 
      `
		}
	},
  };
  </script>
  
  <style scoped>
  .popup {
	position: fixed;
	top: 6%;
	left: 2%;
	width: 96%;
	height: 80%; /* 设置弹窗高度为屏幕高度 */
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	color:black;
	text-align: left;
	line-height:1.5;
	min-width: 340px;
	min-height: 95%;
  }
  
  .popup-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 95%;
	z-index: 1;
  }
  
  .popup-content {
	background-color: white;
	padding: 10px;
	border-radius: 5px;
	max-width: 100%;
	min-width: 300px; /* 最小宽度 */
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	height: 90%; /* 设置内容区域高度 */
  }
  
  header {
  	display: flex;
  	justify-content: space-between;
  	align-items: center;
  	margin-bottom: 5px;
  }
  
  .content-area {
	flex-grow: 1; /* 内容区域扩展至可用空间 */
	overflow-y: auto; /* 当内容超出时显示垂直滚动条 */
	max-height: calc(100% - 50px); /* 减去头部的高度 */
	padding: 5px 0;
  }
  
  .agreen_btn {
	margin-top: 5px;
	width: 100%;
	height: 45px;
	border-radius: 25px;
	border: none;
	background-color: #173f35;
	color: #fff;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/PrivacyPopup.vue